import { useEffect } from 'react';
import {useSettingsContext} from './context/settings/useSettingsContext';

const DynamicCssLoader = () => {
    const { loadDefaultFont } = useSettingsContext();

    useEffect(() => {
        if (loadDefaultFont) {
            const link = document.createElement('link');
            link.href = 'https://fonts.googleapis.com/css2?family=Archivo&display=swap';
            link.type = 'text/css';
            link.rel = 'stylesheet';

            document.head.appendChild(link);

            return () => {
                document.head.removeChild(link);
            }
        }
    }, [loadDefaultFont]);

    // This component does not render anything.
    return null;
};

export default DynamicCssLoader;
